const SidebarData = [
  {
    title: "Dashboard",
    active: "Dashboard",
    path: "/",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M2.18401 21.818L2.1829 21.8168C1.88727 21.5218 1.75 21.1899 1.75 20.7802V3.22148C1.75 2.81186 1.88727 2.47987 2.1829 2.18487L2.18401 2.18375C2.47902 1.88813 2.811 1.75085 3.22062 1.75085H9.09188C9.5015 1.75085 9.83348 1.88813 10.1285 2.18375L10.1296 2.18487C10.4252 2.47987 10.5625 2.81186 10.5625 3.22148V20.7802C10.5625 21.1899 10.4252 21.5218 10.1296 21.8168L10.1285 21.818C9.83348 22.1136 9.5015 22.2509 9.09188 22.2509H3.22062C2.811 22.2509 2.47902 22.1136 2.18401 21.818ZM13.8715 21.818L13.8704 21.8168C13.5748 21.5218 13.4375 21.1899 13.4375 20.7802V14.2215C13.4375 13.8119 13.5748 13.4799 13.8704 13.1849C14.1668 12.8891 14.4996 12.7516 14.9087 12.7509C14.9089 12.7509 14.9091 12.7509 14.9093 12.7509L20.7794 12.7509C21.189 12.7509 21.521 12.8881 21.816 13.1838L21.8171 13.1849C22.1127 13.4799 22.25 13.8119 22.25 14.2215V20.7802C22.25 21.1899 22.1127 21.5218 21.8171 21.8168L21.816 21.818C21.521 22.1136 21.189 22.2509 20.7794 22.2509H14.9081C14.4985 22.2509 14.1665 22.1136 13.8715 21.818ZM13.8715 9.44296L13.8704 9.44184C13.5748 9.14684 13.4375 8.81485 13.4375 8.40523V3.22148C13.4375 2.81186 13.5748 2.47987 13.8704 2.18487L13.8715 2.18375C14.1665 1.88813 14.4985 1.75085 14.9081 1.75085H20.7794C21.189 1.75085 21.521 1.88813 21.816 2.18375L21.8171 2.18487C22.1127 2.47987 22.25 2.81186 22.25 3.22148V8.40523C22.25 8.81485 22.1127 9.14684 21.8171 9.44184L21.816 9.44296C21.521 9.73858 21.189 9.87585 20.7794 9.87585H14.9081C14.4985 9.87585 14.1665 9.73858 13.8715 9.44296Z"
          stroke="#0D2D44"
          stroke-width="1.5"
        />
      </svg>
    ),
  },
  {
    title: "Account Metrics",
    active: "Account Metrics",
    path: "/account-metrics/",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M2 12.0009C2 7.28685 2 4.92985 3.464 3.46485C4.93 2.00085 7.286 2.00085 12 2.00085C16.714 2.00085 19.071 2.00085 20.535 3.46485C22 4.93085 22 7.28685 22 12.0009C22 16.7149 22 19.0719 20.535 20.5359C19.072 22.0009 16.714 22.0009 12 22.0009C7.286 22.0009 4.929 22.0009 3.464 20.5359C2 19.0729 2 16.7149 2 12.0009Z"
          stroke="#526C7B"
          stroke-width="1.5"
        />
        <path
          d="M7 14.0009L9.293 11.7079C9.48053 11.5204 9.73484 11.4151 10 11.4151C10.2652 11.4151 10.5195 11.5204 10.707 11.7079L12.293 13.2939C12.4805 13.4813 12.7348 13.5866 13 13.5866C13.2652 13.5866 13.5195 13.4813 13.707 13.2939L17 10.0009M17 10.0009V12.5009M17 10.0009H14.5"
          stroke="#526C7B"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),

    childrens: [
      {
        title: "Program Objectives",
        subMenuActive: "Program Objectives",
        active: "Account Metrics",
        path: "/account-metrics/program-objectives",
      },
      {
        title: "Trading History",
        subMenuActive: "Trading History",
        active: "Account Metrics",
        path: "/account-metrics/trading-history",
      },
      {
        title: "Account Info",
        subMenuActive: "Account Info",
        active: "Account Metrics",
        path: "/account-metrics/account-info",
      },
    ],
  },
  {
    title: "Choose challenge",
    active: "Choose challenge",
    path: `/funding-evaluation/plans/${0}`,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <circle
          cx="12"
          cy="12"
          r="10.25"
          stroke="#526C7B"
          stroke-width="1.5"
        />
        <path
          d="M9 12.5L9.53033 11.9697L9 11.4393L8.46967 11.9697L9 12.5ZM11.5 15L10.9697 15.5303L11.5 16.0607L12.0303 15.5303L11.5 15ZM18.25 9C18.25 8.58579 17.9142 8.25 17.5 8.25H10.75C10.3358 8.25 10 8.58579 10 9C10 9.41421 10.3358 9.75 10.75 9.75H16.75V15.75C16.75 16.1642 17.0858 16.5 17.5 16.5C17.9142 16.5 18.25 16.1642 18.25 15.75V9ZM4.53033 18.0303L9.53033 13.0303L8.46967 11.9697L3.46967 16.9697L4.53033 18.0303ZM8.46967 13.0303L10.9697 15.5303L12.0303 14.4697L9.53033 11.9697L8.46967 13.0303ZM12.0303 15.5303L18.0303 9.53033L16.9697 8.46967L10.9697 14.4697L12.0303 15.5303Z"
          fill="#526C7B"
        />
      </svg>
    ),
    childrens: [
      {
        title: "Free Trial",
        subMenuActive: "Free Trial",
        active: "Choose challenge",
        path: `/funding-evaluation/plans/${0}`,
      },
      {
        title: "Standard Plan",
        subMenuActive: "Standard Plan",
        active: "Choose challenge",
        path: `/funding-evaluation/plans/${1}`,
      },
    ],
  },
  // {
  //   title: "Buy Funded Account",
  //   active: "Buy Funded Account",
  //   path: "/evaluation/payment/buy-funded",
  //   icon: (
  //     <svg
  //       width="24"
  //       height="22"
  //       viewBox="0 0 16 22"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <path
  //         d="M1.61757 10.5388H4.75252V10.6375H1.61757C0.982929 10.6375 0.468262 10.1229 0.468262 9.48821V1.53994C0.468262 0.905292 0.982929 0.390625 1.61757 0.390625H14.3315C14.9662 0.390625 15.4808 0.905292 15.4808 1.53994V9.37821C15.4808 10.0129 14.9662 10.5275 14.3315 10.5275H12.6432V10.4288H14.3315C14.9116 10.4288 15.3821 9.95835 15.3821 9.37821V1.53994C15.3821 0.959798 14.9116 0.489339 14.3315 0.489339H1.61757C1.03743 0.489339 0.566976 0.959798 0.566976 1.53994V9.48821C0.566976 10.0683 1.03743 10.5388 1.61757 10.5388Z"
  //         fill="#0D2D44"
  //         stroke="#0D2D44"
  //         stroke-width="0.78125"
  //       />
  //       <path
  //         d="M8.82667 3.55623C8.82667 3.05499 8.42044 2.64876 7.91921 2.64876C7.41798 2.64876 7.01175 3.05499 7.01175 3.55623C7.01175 4.05746 7.41798 4.46369 7.91921 4.46369C8.42044 4.46369 8.82667 4.05746 8.82667 3.55623ZM9.70664 3.55623C9.70664 4.54346 8.90644 5.34365 7.91921 5.34365C6.93198 5.34365 6.13178 4.54346 6.13178 3.55623C6.13178 2.56899 6.93198 1.7688 7.91921 1.7688C8.90644 1.7688 9.70664 2.56899 9.70664 3.55623ZM2.85942 6.99359H13.0615C13.3045 6.99359 13.5015 6.7966 13.5015 6.5536C13.5015 6.3106 13.3045 6.11362 13.0615 6.11362H2.85942C2.61642 6.11362 2.41943 6.3106 2.41943 6.5536C2.41943 6.7966 2.61642 6.99359 2.85942 6.99359ZM2.85942 8.97351H8.2877C8.5307 8.97351 8.72768 8.77652 8.72768 8.53352C8.72768 8.29052 8.5307 8.09354 8.2877 8.09354H2.85942C2.61642 8.09354 2.41943 8.29052 2.41943 8.53352C2.41943 8.77652 2.61642 8.97351 2.85942 8.97351ZM9.83779 11.0269C10.0808 11.0269 10.2778 10.8299 10.2778 10.5869C10.2778 10.3439 10.0808 10.147 9.83779 10.147H4.10636C3.86336 10.147 3.66638 10.3439 3.66638 10.5869V12.8698C3.66635 13.0772 3.71521 13.2817 3.80899 13.4667L5.12189 16.0556C5.18449 16.1789 5.2171 16.3153 5.21708 16.4536V21.5493C5.21708 21.7923 5.41406 21.9893 5.65706 21.9893C5.90006 21.9893 6.09704 21.7923 6.09704 21.5493V16.4536C6.09709 16.1769 6.03184 15.9041 5.90659 15.6574L4.59378 13.0687C4.56255 13.007 4.54629 12.9389 4.54632 12.8698V11.0269H9.83777L9.83779 11.0269ZM10.7169 21.5493V16.8404C10.7168 16.6873 10.7488 16.5359 10.8107 16.3959C10.8725 16.2559 10.9629 16.1304 11.0761 16.0273L12.0744 15.118C12.2555 14.9531 12.4002 14.7521 12.4992 14.5281C12.5982 14.304 12.6493 14.0618 12.6493 13.8168V11.5533C12.6493 11.3103 12.4523 11.1133 12.2093 11.1133C11.9663 11.1133 11.7693 11.3103 11.7693 11.5533V13.8168C11.7693 13.9393 11.7438 14.0604 11.6943 14.1724C11.6448 14.2844 11.5725 14.3849 11.4819 14.4673L10.4837 15.3767C10.2799 15.5622 10.1171 15.7882 10.0058 16.0402C9.89439 16.2923 9.83687 16.5648 9.83689 16.8404V21.5493C9.83689 21.7923 10.0339 21.9893 10.2769 21.9893C10.5199 21.9893 10.7169 21.7923 10.7169 21.5493Z"
  //         fill="#0D2D44"
  //       />
  //       <path
  //         d="M10.4425 11.7114V9.15224C10.4425 8.78771 10.7379 8.49227 11.1024 8.49227C11.4762 8.49227 11.7716 8.78771 11.7716 9.15224V12.1514C11.7716 12.3944 11.9686 12.5914 12.2116 12.5914C12.4546 12.5914 12.6516 12.3944 12.6516 12.1514V9.15224C12.6516 8.30169 11.9621 7.6123 11.1117 7.6123C10.252 7.6123 9.5625 8.30169 9.5625 9.15224V11.7114C9.5625 11.9544 9.75948 12.1514 10.0025 12.1514C10.2455 12.1514 10.4425 11.9544 10.4425 11.7114Z"
  //         fill="#0D2D44"
  //       />
  //     </svg>
  //   ),
  // },
  {
    title: "Affiliate",
    active: "Affiliate",
    path: "/affiliate",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M17.0587 15.5219C17.5265 15.2024 18.0752 15.0219 18.6413 15.0013C19.2074 14.9807 19.7678 15.1207 20.2576 15.4053C20.7474 15.6898 21.1466 16.1072 21.4091 16.6092C21.6716 17.1112 21.7865 17.6772 21.7407 18.2419C20.5409 18.6612 19.2665 18.8244 17.9997 18.7209C17.9958 17.5875 17.6695 16.4776 17.0587 15.5229C16.5166 14.6726 15.7689 13.9729 14.8846 13.4884C14.0003 13.0038 13.0081 12.7502 11.9997 12.7509C10.9916 12.7503 9.99957 13.0041 9.11547 13.4886C8.23137 13.9731 7.48374 14.6728 6.94174 15.5229M17.9987 18.7199L17.9997 18.7509C17.9997 18.9759 17.9877 19.1979 17.9627 19.4169C16.1481 20.458 14.0918 21.0042 11.9997 21.0009C9.82974 21.0009 7.79274 20.4249 6.03674 19.4169C6.01103 19.1854 5.99868 18.9527 5.99974 18.7199M5.99974 18.7199C4.73337 18.8271 3.45965 18.6645 2.26074 18.2429C2.21509 17.6784 2.33014 17.1126 2.59257 16.6107C2.855 16.1089 3.25411 15.6917 3.74374 15.4071C4.23338 15.1226 4.79354 14.9825 5.35946 15.003C5.92538 15.0235 6.47395 15.2037 6.94174 15.5229M5.99974 18.7199C6.00333 17.5866 6.33136 16.4777 6.94174 15.5229M14.9997 6.75085C14.9997 7.5465 14.6837 8.30957 14.1211 8.87218C13.5585 9.43478 12.7954 9.75085 11.9997 9.75085C11.2041 9.75085 10.441 9.43478 9.87842 8.87218C9.31581 8.30957 8.99974 7.5465 8.99974 6.75085C8.99974 5.95521 9.31581 5.19214 9.87842 4.62953C10.441 4.06693 11.2041 3.75085 11.9997 3.75085C12.7954 3.75085 13.5585 4.06693 14.1211 4.62953C14.6837 5.19214 14.9997 5.95521 14.9997 6.75085ZM20.9997 9.75085C20.9997 10.0463 20.9415 10.3389 20.8285 10.6119C20.7154 10.8849 20.5497 11.1329 20.3407 11.3418C20.1318 11.5508 19.8838 11.7165 19.6108 11.8296C19.3378 11.9427 19.0452 12.0009 18.7497 12.0009C18.4543 12.0009 18.1617 11.9427 17.8887 11.8296C17.6157 11.7165 17.3677 11.5508 17.1588 11.3418C16.9498 11.1329 16.7841 10.8849 16.671 10.6119C16.5579 10.3389 16.4997 10.0463 16.4997 9.75085C16.4997 9.15412 16.7368 8.58182 17.1588 8.15986C17.5807 7.73791 18.153 7.50085 18.7497 7.50085C19.3465 7.50085 19.9188 7.73791 20.3407 8.15986C20.7627 8.58182 20.9997 9.15412 20.9997 9.75085ZM7.49974 9.75085C7.49974 10.0463 7.44154 10.3389 7.32847 10.6119C7.2154 10.8849 7.04966 11.1329 6.84073 11.3418C6.6318 11.5508 6.38376 11.7165 6.11078 11.8296C5.8378 11.9427 5.54522 12.0009 5.24974 12.0009C4.95427 12.0009 4.66169 11.9427 4.3887 11.8296C4.11572 11.7165 3.86768 11.5508 3.65875 11.3418C3.44982 11.1329 3.28409 10.8849 3.17101 10.6119C3.05794 10.3389 2.99974 10.0463 2.99974 9.75085C2.99974 9.15412 3.23679 8.58182 3.65875 8.15986C4.08071 7.73791 4.653 7.50085 5.24974 7.50085C5.84648 7.50085 6.41877 7.73791 6.84073 8.15986C7.26269 8.58182 7.49974 9.15412 7.49974 9.75085Z"
          stroke="#526C7B"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),

    childrens: [
      {
        title: "Overview",
        active: "Affiliate",
        subMenuActive: "Overview",
        path: "/affiliate/overview",
      },
      {
        title: "Get a link",
        active: "Affiliate",
        subMenuActive: "Get a link",
        path: "/affiliate/get-a-link",
      },
    ],
  },
  {
    title: "Payments",
    active: "Payments",
    path: "/funding-evaluation-payment/payment-history/",
    icon: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 12.3301C21 11.7514 20.7629 11.1965 20.341 10.7873C19.919 10.3781 19.3467 10.1483 18.75 10.1483H15C15 10.9198 14.6839 11.6597 14.1213 12.2053C13.5587 12.7509 12.7956 13.0574 12 13.0574C11.2044 13.0574 10.4413 12.7509 9.87868 12.2053C9.31607 11.6597 9 10.9198 9 10.1483H5.25C4.65326 10.1483 4.08097 10.3781 3.65901 10.7873C3.23705 11.1965 3 11.7514 3 12.3301M21 12.3301V18.1483C21 18.7269 20.7629 19.2819 20.341 19.691C19.919 20.1002 19.3467 20.3301 18.75 20.3301H5.25C4.65326 20.3301 4.08097 20.1002 3.65901 19.691C3.23705 19.2819 3 18.7269 3 18.1483V12.3301M21 12.3301V9.42099M3 12.3301V9.42099M21 9.42099C21 8.84233 20.7629 8.28738 20.341 7.87821C19.919 7.46904 19.3467 7.23917 18.75 7.23917H5.25C4.65326 7.23917 4.08097 7.46904 3.65901 7.87821C3.23705 8.28738 3 8.84233 3 9.42099M21 9.42099V6.5119C21 5.93324 20.7629 5.37829 20.341 4.96912C19.919 4.55995 19.3467 4.33008 18.75 4.33008H5.25C4.65326 4.33008 4.08097 4.55995 3.65901 4.96912C3.23705 5.37829 3 5.93324 3 6.5119V9.42099"
          stroke="#6A796E"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
  {
    title: "Withdrawals",
    active: "Withdrawals",
    path: "/request-payout/",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 9C19 10.45 18.57 11.78 17.83 12.89C16.75 14.49 15.04 15.62 13.05 15.91C12.71 15.97 12.36 16 12 16C11.64 16 11.29 15.97 10.95 15.91C8.96 15.62 7.25 14.49 6.17 12.89C5.43 11.78 5 10.45 5 9C5 5.13 8.13 2 12 2C15.87 2 19 5.13 19 9Z"
          stroke="#526C7B"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.2491 18.4704L19.5991 18.8604C19.2291 18.9504 18.9391 19.2304 18.8591 19.6004L18.5091 21.0704C18.3191 21.8704 17.2991 22.1104 16.7691 21.4804L11.9991 16.0004L7.2291 21.4904C6.6991 22.1204 5.6791 21.8804 5.4891 21.0804L5.1391 19.6104C5.0491 19.2404 4.7591 18.9504 4.3991 18.8704L2.7491 18.4804C1.9891 18.3004 1.7191 17.3504 2.2691 16.8004L6.1691 12.9004C7.2491 14.5004 8.9591 15.6304 10.9491 15.9204C11.2891 15.9804 11.6391 16.0104 11.9991 16.0104C12.3591 16.0104 12.7091 15.9804 13.0491 15.9204C15.0391 15.6304 16.7491 14.5004 17.8291 12.9004L21.7291 16.8004C22.2791 17.3404 22.0091 18.2904 21.2491 18.4704Z"
          stroke="#526C7B"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.58 5.98L13.17 7.15999C13.25 7.31999 13.46 7.48 13.65 7.51L14.72 7.68999C15.4 7.79999 15.56 8.3 15.07 8.79L14.24 9.61998C14.1 9.75998 14.02 10.03 14.07 10.23L14.31 11.26C14.5 12.07 14.07 12.39 13.35 11.96L12.35 11.37C12.17 11.26 11.87 11.26 11.69 11.37L10.69 11.96C9.96997 12.38 9.53997 12.07 9.72997 11.26L9.96997 10.23C10.01 10.04 9.93997 9.75998 9.79997 9.61998L8.96997 8.79C8.47997 8.3 8.63997 7.80999 9.31997 7.68999L10.39 7.51C10.57 7.48 10.78 7.31999 10.86 7.15999L11.45 5.98C11.74 5.34 12.26 5.34 12.58 5.98Z"
          stroke="#526C7B"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    childrens: [
      {
        title: "Trading account",
        subMenuActive: "Trading account",
        active: "Withdrawals",
        path: "/request-payout/payout-split",
      },
      {
        title: "Affiliate Payout",
        subMenuActive: "Affiliate Payout",
        active: "Withdrawals",
        path: "/request-payout/affiliate-payout",
      },
      // {
      //   title: "Payment History",
      //   subMenuActive: "Payment History",
      //   active: "Withdrawals",
      //   path: "/request-payout/affiliate-payout",
      // },
    ],
  },
  {
    title: "KYC",
    active: "KYC",
    path: "/verification-kyc/*",
    icon: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.38086 12.3302L10.7909 14.7502L15.6209 9.91016"
          stroke="#6A796E"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.7509 2.78039C11.4409 2.19039 12.5709 2.19039 13.2709 2.78039L14.8509 4.14039C15.1509 4.40039 15.7109 4.61039 16.1109 4.61039H17.8109C18.8709 4.61039 19.7409 5.48039 19.7409 6.54039V8.24039C19.7409 8.63039 19.9509 9.20039 20.2109 9.50039L21.5709 11.0803C22.1609 11.7703 22.1609 12.9003 21.5709 13.6003L20.2109 15.1803C19.9509 15.4803 19.7409 16.0403 19.7409 16.4403V18.1403C19.7409 19.2003 18.8709 20.0703 17.8109 20.0703H16.1109C15.7209 20.0703 15.1509 20.2803 14.8509 20.5403L13.2709 21.9003C12.5809 22.4903 11.4509 22.4903 10.7509 21.9003L9.17086 20.5403C8.87086 20.2803 8.31086 20.0703 7.91086 20.0703H6.18086C5.12086 20.0703 4.25086 19.2003 4.25086 18.1403V16.4303C4.25086 16.0403 4.04086 15.4803 3.79086 15.1803L2.44086 13.5903C1.86086 12.9003 1.86086 11.7803 2.44086 11.0903L3.79086 9.50039C4.04086 9.20039 4.25086 8.64039 4.25086 8.25039V6.53039C4.25086 5.47039 5.12086 4.60039 6.18086 4.60039H7.91086C8.30086 4.60039 8.87086 4.39039 9.17086 4.13039L10.7509 2.78039Z"
          stroke="#6A796E"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
  // {
  //   title: "Billing Details",
  //   active: "Billing Details",
  //   path: "/billing-details",
  //   icon: (
  //     <svg
  //       width="24"
  //       height="21"
  //       viewBox="0 0 20 21"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <path
  //         d="M15.625 19.3303C16.2666 18.76 17.2334 18.76 17.875 19.3303C18.3109 19.7177 19 19.4083 19 18.8251V1.83527C19 1.25204 18.3109 0.942589 17.875 1.33007C17.2334 1.90037 16.2666 1.90037 15.625 1.33007C14.9834 0.759769 14.0166 0.759769 13.375 1.33007C12.7334 1.90037 11.7666 1.90037 11.125 1.33007C10.4834 0.759769 9.5166 0.759769 8.875 1.33007C8.2334 1.90037 7.26659 1.90037 6.625 1.33007C5.98341 0.759769 5.01659 0.759769 4.375 1.33007C3.73341 1.90037 2.76659 1.90037 2.125 1.33007C1.68909 0.942589 1 1.25204 1 1.83527V18.8251C1 19.4083 1.68909 19.7177 2.125 19.3303C2.76659 18.76 3.73341 18.76 4.375 19.3303C5.01659 19.9006 5.98341 19.9006 6.625 19.3303C7.26659 18.76 8.2334 18.76 8.875 19.3303C9.5166 19.9006 10.4834 19.9006 11.125 19.3303C11.7666 18.76 12.7334 18.76 13.375 19.3303C14.0166 19.9006 14.9834 19.9006 15.625 19.3303Z"
  //         stroke="#6A796E"
  //         stroke-width="1.5"
  //       />
  //       <path
  //         d="M5.5 13.8301H14.5"
  //         stroke="#6A796E"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //       />
  //       <path
  //         d="M5.5 10.3301H14.5"
  //         stroke="#6A796E"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //       />
  //       <path
  //         d="M5.5 6.83008H14.5"
  //         stroke="#6A796E"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //       />
  //     </svg>
  //   ),
  // },
  // {
  //   title: "Market Analysis",
  //   active: "Market Analysis",
  //   path: "/trademate",
  //   icon: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="24"
  //       height="24"
  //       viewBox="0 0 22 24"
  //       fill="none"
  //     >
  //       <path
  //         d="M1 9.77669H5.44444V17.5545H1V9.77669ZM8.77778 6.44336H13.2222V20.8878H8.77778V6.44336Z"
  //         stroke="#526C7B"
  //         stroke-width="1.5"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M11 23.1109V20.8887"
  //         stroke="#526C7B"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M16.5547 5.33398H20.9991V10.334H16.5547V5.33398Z"
  //         stroke="#526C7B"
  //         stroke-width="1.5"
  //         stroke-linejoin="round"
  //       />
  //       <path
  //         d="M3.22266 9.77756V4.22201M18.7782 17.5553V10.3331M18.7782 5.33312V0.888672"
  //         stroke="#526C7B"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //     </svg>
  //   ),
  //   childrens: [
  //     {
  //       title: "Trade Journal",
  //       subMenuActive: "Trade Journal",
  //       active: "Market Analysis",
  //       path: "/trademate/trade-journal",
  //     },
  //     {
  //       title: "Economic Calendar",
  //       subMenuActive: "Economic Calendar",
  //       active: "Market Analysis",
  //       path: "/trademate/economic-calendar",
  //     },
  //     {
  //       title: "Market News",
  //       subMenuActive: "Market News",
  //       active: "Market Analysis",
  //       path: "/trademate/market-news",
  //     },
  //   ],
  // },
  {
    title: "Contract",
    active: "Contract",
    path: "/Contract-list",
    icon: (
      <svg
        fill="#526c7b"
        height="24px"
        width="23px"
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 315.752 315.752"
      >
        <g>
          <path
            d="M263.89,8.743c-3.039,0-5.503,2.464-5.503,5.503v257.607c0,0.854,0.199,1.696,0.581,2.461l14.829,29.654
		c0.932,1.864,2.837,3.042,4.922,3.042c2.084,0,3.989-1.178,4.922-3.042l14.828-29.654c0.382-0.765,0.581-1.606,0.581-2.461V14.246
		c0-3.039-2.464-5.503-5.503-5.503H263.89z M288.044,270.552l-9.325,18.649l-9.326-18.649V19.749h18.651V270.552z"
          />
          <path
            d="M304.746,48.037v87.789c0,3.039,2.464,5.503,5.503,5.503c3.039,0,5.503-2.464,5.503-5.503V48.037
		c0-3.039-2.464-5.503-5.503-5.503C307.21,42.534,304.746,44.998,304.746,48.037z"
          />
          <path
            d="M186.526,164.64H47.204c-3.039,0-5.503,2.465-5.503,5.504c0,3.039,2.464,5.502,5.503,5.502h139.322
		c3.039,0,5.503-2.463,5.503-5.502C192.029,167.105,189.565,164.64,186.526,164.64z"
          />
          <path
            d="M186.526,246.068H47.204c-3.039,0-5.503,2.464-5.503,5.503c0,3.039,2.464,5.503,5.503,5.503h139.322
		c3.039,0,5.503-2.464,5.503-5.503C192.029,248.532,189.565,246.068,186.526,246.068z"
          />
          <path
            d="M186.526,129.295H47.204c-3.039,0-5.503,2.464-5.503,5.503c0,3.039,2.464,5.503,5.503,5.503h139.322
		c3.039,0,5.503-2.464,5.503-5.503C192.029,131.759,189.565,129.295,186.526,129.295z"
          />
          <path
            d="M47.204,104.959h82.709c3.039,0,5.503-2.465,5.503-5.504c0-3.039-2.464-5.502-5.503-5.502H47.204
		c-3.039,0-5.503,2.463-5.503,5.502C41.701,102.494,44.165,104.959,47.204,104.959z"
          />
          <path
            d="M47.204,69.615h82.709c3.039,0,5.503-2.463,5.503-5.502c0-3.039-2.464-5.504-5.503-5.504H47.204
		c-3.039,0-5.503,2.465-5.503,5.504C41.701,67.152,44.165,69.615,47.204,69.615z"
          />
          <path
            d="M5.488,306.568h222.754c3.031,0,5.488-2.457,5.488-5.488V87.843l0,0l0,0c0-0.008-0.001-0.015-0.001-0.022
		c-0.001-0.177-0.01-0.353-0.027-0.525c-0.013-0.134-0.036-0.265-0.059-0.396c-0.008-0.045-0.012-0.091-0.02-0.136
		c-0.031-0.154-0.071-0.308-0.115-0.459c-0.006-0.02-0.01-0.04-0.016-0.061c-0.047-0.15-0.102-0.299-0.16-0.446
		c-0.008-0.019-0.014-0.039-0.021-0.058c-0.057-0.138-0.122-0.271-0.191-0.402c-0.014-0.027-0.025-0.057-0.04-0.084
		c-0.064-0.119-0.136-0.234-0.208-0.349c-0.024-0.037-0.045-0.077-0.069-0.113c-0.069-0.103-0.146-0.202-0.223-0.301
		c-0.033-0.043-0.064-0.089-0.098-0.132c-0.095-0.115-0.197-0.225-0.303-0.333c-0.02-0.021-0.036-0.043-0.057-0.063l-73.174-73.173
		c-0.127-0.127-0.26-0.246-0.397-0.359c-0.036-0.029-0.075-0.055-0.111-0.083c-0.105-0.082-0.211-0.164-0.32-0.237
		c-0.032-0.021-0.067-0.04-0.1-0.061c-0.118-0.076-0.238-0.15-0.361-0.217c-0.022-0.012-0.047-0.021-0.069-0.033
		c-0.137-0.071-0.275-0.139-0.417-0.197c-0.016-0.007-0.032-0.012-0.047-0.018c-0.15-0.061-0.303-0.116-0.457-0.164
		c-0.018-0.005-0.035-0.008-0.053-0.013c-0.153-0.046-0.309-0.086-0.467-0.118c-0.043-0.008-0.089-0.012-0.132-0.02
		c-0.133-0.023-0.266-0.047-0.4-0.06c-0.181-0.019-0.364-0.028-0.548-0.028l0,0H5.488C2.457,9.183,0,11.64,0,14.671V301.08
		C0,304.111,2.457,306.568,5.488,306.568z M214.995,82.357l-54.434,0.006l-0.003-54.441L214.995,82.357z M10.976,20.16h138.605
		l0.004,67.692c0,1.456,0.578,2.852,1.607,3.881c1.029,1.028,2.426,1.606,3.881,1.606l67.682-0.008v202.261H10.976V20.16z"
          />
        </g>
      </svg>
    ),
  },
  {
    title: "Certificates",
    active: "Certificates",
    path: "/certificates",
    icon: (
      <svg
        fill="#526c7b"
        height="24px"
        width="24px"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 64 64"
        enable-background="new 0 0 64 64"
      >
        <g id="Certificate-file">
          <path
            d="M54.1076508,14.717124c-0.0053024-0.0955-0.0237999-0.1876001-0.0559006-0.2779007
		c-0.0102005-0.0284996-0.0171013-0.0567999-0.0298004-0.0840998c-0.0480995-0.1046-0.1090012-0.2038994-0.1932983-0.2884998
		c0,0-3.4248009-3.4394999-6.8535004-6.8759999c-1.7139015-1.7188001-3.4297028-3.4356-4.7187996-4.7227001
		c-0.9531021-0.9511001-1.5810013-1.5781001-2.0234032-1.9677001c-0.006897-0.0098-0.0136986-0.0186-0.0205002-0.0284
		c-0.0009995-0.0019-0.0019989-0.0029-0.0029984-0.0048l-0.0078011,0.0058c-0.6213989-0.5415-0.8670006-0.6004-1.1478996-0.4306
		l-26.0746994,0.0009c-1.7079992,0-3.0977001,1.3907001-3.0977001,3.0996001v50.5655022
		c0,0.8661995,0.3369007,1.6805992,0.9522009,2.2967987c0.6053991,0.6026001,1.4413996,0.9482994,2.2928991,0.9482994h13.1513996
		c0.5527,0,1-0.4473,1-1c0-0.5527992-0.4473-1-1-1H13.1264496c-0.3270998,0-0.6483994-0.1338005-0.8799-0.3633003
		c-0.2323999-0.232399-0.3652-0.5536995-0.3652-0.8817978V3.1427238c0-0.6064,0.4922009-1.0996001,1.0977001-1.0996001
		l25.4626007-0.0009c0.0377007,2.2823002-0.0049019,8.6077995-0.0485992,12.7186995
		c-0.002903,0.2676001,0.1016006,0.5244007,0.2891006,0.7139006c0.1875,0.1904001,0.4442978,0.2967997,0.7108994,0.2967997
		h12.7255974v38.0997009c0,0.2851028-0.1152,0.5634003-0.3173981,0.7656021
		c-0.2041016,0.2040977-0.4756012,0.3163986-0.7645988,0.3163986h-0.455101c-0.5527,0-1,0.4472008-1,1c0,0.5527,0.4473,1,1,1
		h0.455101c0.8241997,0,1.5985985-0.3213005,2.1796989-0.9033012c0.5732002-0.5732994,0.902298-1.3671989,0.902298-2.1786995
		V14.7716236C54.1186485,14.7523241,54.1087494,14.7362242,54.1076508,14.717124z M40.4038506,13.7716236
		C40.45755,8.5080242,40.4741516,5.380024,40.4585495,3.4992237c2.3398018,2.3340001,6.6297989,6.6346998,10.2538986,10.2723999
		H40.4038506z"
          />
          <path
            d="M46.4301491,49.4289246c-0.0370979-0.1273003-0.0993004-0.2401009-0.1764984-0.3384018
		c1.4456978-1.7341003,2.3171997-3.9636993,2.3171997-6.3979988c0-5.5228004-4.4771996-10-10-10c-5.5228996,0-10,4.4771996-10,10
		c0,2.5708008,0.9783993,4.9075012,2.5725002,6.6790009L27.7680492,60.942524
		c-0.1103001,0.3779984,0.0117016,0.7862015,0.3116016,1.0419998c0.299799,0.2549019,0.7206993,0.3086014,1.0770988,0.1416016
		l3.4014015-1.6162033l2.1376991,3.0996017c0.1884003,0.2734985,0.4980011,0.4326973,0.8232002,0.4326973
		c0.0565987,0,0.1133003-0.0048981,0.169899-0.0146942c0.3848-0.0664024,0.6953011-0.3496017,0.7959023-0.7266045
		l2.2945976-8.5613976l2.2943001,8.5613976c0.1006012,0.3760033,0.410202,0.6592026,0.7938995,0.7266045
		c0.0577011,0.0097961,0.1152992,0.0146942,0.1719017,0.0146942c0.3241997,0,0.6319008-0.157299,0.8213005-0.4296989
		l2.1436005-3.0839996l3.3993988,1.5996017c0.3554001,0.1660004,0.7753983,0.1102982,1.0760994-0.1455002
		c0.2989006-0.2549019,0.4199982-0.6621017,0.3096008-1.0401001L46.4301491,49.4289246z M38.5708504,34.5973244
		c4.4636993,0,8.0951996,3.6315002,8.0951996,8.0951996c0,4.4637985-3.6315002,8.0952988-8.0951996,8.0952988
		c-4.4637985,0-8.0953007-3.6315002-8.0953007-8.0952988C30.4755497,38.2288246,34.1070518,34.5973244,38.5708504,34.5973244z
		 M35.1137505,60.692524l-1.3925018-2.0185013c-0.2792969-0.4043007-0.809597-0.5478973-1.2519989-0.3359985l-2.1571999,1.024498
		l2.4841995-8.5150986c1.3003006,0.9225998,2.8286018,1.5391998,4.4862022,1.7528992L35.1137505,60.692524z M45.0913506,58.3586235
		c-0.4424019-0.2080994-0.9687996-0.0654984-1.2471008,0.3348999l-1.3964996,2.0088005l-2.1875992-8.1632004
		c1.6489983-0.2812004,3.1576996-0.9631996,4.4260979-1.9464989l2.5623016,8.781601L45.0913506,58.3586235z"
          />
          <path
            d="M38.5708504,47.692524c2.7613983,0,5-2.2384987,5-5c0-2.7613983-2.2386017-5-5-5c-2.7614021,0-5,2.2386017-5,5
		C33.5708504,45.4540253,35.8094482,47.692524,38.5708504,47.692524z M38.5708504,39.692524c1.6542015,0,3,1.3457985,3,3
		c0,1.6543007-1.3457985,3-3,3c-1.6543007,0-3-1.3456993-3-3C35.5708504,41.0383224,36.9165497,39.692524,38.5708504,39.692524z"
          />
        </g>
      </svg>
    ),
  },
  {
    title: "Support",
    active: "Support",
    // email: "support@example.com",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="22"
        viewBox="0 0 19 22"
        fill="none"
      >
        <path
          d="M10.712 20.8261L10.5267 18.6376L10.4686 17.9509H9.77941H9.5C7.04685 17.9509 4.99264 17.1173 3.29227 15.4438C1.59238 13.7708 0.75 11.7546 0.75 9.35085C0.75 6.94711 1.59238 4.93094 3.29227 3.25789C4.99264 1.58437 7.04685 0.750854 9.5 0.750854C10.7284 0.750854 11.8625 0.975802 12.9102 1.41964C13.9712 1.86913 14.8973 2.48597 15.6941 3.27086C16.4911 4.05594 17.1164 4.96639 17.5719 6.00724C18.0213 7.03421 18.2493 8.14607 18.25 9.35128C18.25 10.6414 18.0363 11.8751 17.6104 13.0565C17.1787 14.2542 16.5882 15.3639 15.8379 16.3875L15.8375 16.388C15.0864 17.4148 14.1914 18.3488 13.1497 19.1898C12.3872 19.8053 11.5749 20.3507 10.712 20.8261Z"
          stroke="#526C7B"
          stroke-width="1.5"
        />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="12"
          viewBox="0 -3 8 12"
          fill="none"
        >
          <path
            d="M1 3.66752C1 2.19476 2.34315 1.00085 4 1.00085C5.65685 1.00085 7 2.19592 7 3.66752C7 5.02091 5.48544 6.0217 4.60861 6.4877C4.24811 6.67929 4 7.0461 4 7.45434V9.00085"
            stroke="#526C7B"
            stroke-width="1.5"
          />
          <path
            d="M4 10.0009V11.5009"
            stroke="#526C7B"
            stroke-width="1.5"
          />
        </svg>
      </svg>
    ),
  },

  {
    title: "Settings",
    active: "Settings",
    path: "/myprofile/general-information",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
      >
        <path
          d="M19.3501 7.92383L18.9841 7.71983C18.662 7.55396 18.391 7.30372 18.2001 6.99583C18.1831 6.96883 18.1671 6.93983 18.1351 6.88383C17.9196 6.53771 17.8149 6.13405 17.8351 5.72683L17.8411 5.30183C17.8531 4.62183 17.8591 4.27983 17.7631 3.97383C17.6782 3.70154 17.536 3.45059 17.3461 3.23783C17.1321 2.99783 16.8351 2.82583 16.2401 2.48383L15.7461 2.19883C15.1541 1.85783 14.8571 1.68683 14.5421 1.62183C14.2638 1.56421 13.9764 1.5666 13.6991 1.62883C13.3861 1.69883 13.0931 1.87483 12.5081 2.22483L12.5051 2.22683L12.1511 2.43783C12.0951 2.47183 12.0661 2.48783 12.0381 2.50383C11.7601 2.65883 11.4501 2.74383 11.1311 2.75383C11.0991 2.75583 11.0661 2.75583 11.0011 2.75583L10.8711 2.75483C10.552 2.74478 10.2399 2.65836 9.96108 2.50283C9.93308 2.48783 9.90608 2.47083 9.85008 2.43683L9.49308 2.22283C8.90408 1.86883 8.60908 1.69283 8.29408 1.62183C8.01574 1.55946 7.72727 1.55742 7.44808 1.61583C7.13208 1.68183 6.83608 1.85383 6.24308 2.19783L6.24008 2.19883L5.75208 2.48183L5.74708 2.48583C5.15908 2.82583 4.86408 2.99783 4.65208 3.23683C4.46316 3.44922 4.32168 3.69945 4.23708 3.97083C4.14208 4.27783 4.14708 4.61983 4.15908 5.30383L4.16608 5.72783C4.16608 5.79283 4.16908 5.82483 4.16808 5.85583C4.1628 6.21913 4.05875 6.57415 3.86708 6.88283C3.83408 6.93883 3.81908 6.96683 3.80208 6.99283C3.63347 7.265 3.40198 7.49271 3.12708 7.65683L3.01508 7.71983L2.65408 7.91983C2.05208 8.25283 1.75108 8.41983 1.53308 8.65783C1.33926 8.86766 1.19264 9.11658 1.10308 9.38783C1.00308 9.69483 1.00308 10.0378 1.00408 10.7258L1.00608 11.2888C1.00708 11.9718 1.00908 12.3128 1.11008 12.6178C1.19926 12.8874 1.34483 13.1349 1.53708 13.3438C1.75508 13.5798 2.05308 13.7458 2.65008 14.0778L3.00808 14.2768C3.06908 14.3108 3.10008 14.3268 3.12908 14.3448C3.44245 14.5327 3.69838 14.8028 3.86908 15.1258L3.93608 15.2458C4.10499 15.5647 4.18447 15.9234 4.16608 16.2838L4.15908 16.6908C4.14708 17.3768 4.14208 17.7208 4.23808 18.0278C4.32308 18.2998 4.46508 18.5508 4.65508 18.7638C4.86908 19.0038 5.16708 19.1748 5.76108 19.5178L6.25508 19.8028C6.84808 20.1438 7.14408 20.3148 7.45908 20.3798C7.73738 20.4374 8.02477 20.435 8.30208 20.3728C8.61608 20.3028 8.90908 20.1268 9.49608 19.7748L9.85008 19.5628C10.155 19.3665 10.5076 19.2569 10.8701 19.2458H11.1301C11.4481 19.2558 11.7601 19.3428 12.0401 19.4978L12.1321 19.5528L12.5081 19.7788C13.0981 20.1328 13.3921 20.3088 13.7071 20.3788C13.9853 20.4418 14.2737 20.4445 14.5531 20.3868C14.8681 20.3208 15.1661 20.1478 15.7591 19.8038L16.2541 19.5168C16.8421 19.1748 17.1371 19.0038 17.3491 18.7648C17.5391 18.5518 17.6791 18.3018 17.7641 18.0308C17.8591 17.7258 17.8541 17.3868 17.8421 16.7128L17.8341 16.2728C17.8142 15.8663 17.9189 15.4633 18.1341 15.1178L18.1991 15.0078C18.3677 14.7357 18.5992 14.5079 18.8741 14.3438L18.9841 14.2828L18.9861 14.2818L19.3471 14.0818C19.9491 13.7478 20.2501 13.5818 20.4691 13.3438C20.6631 13.1338 20.8091 12.8838 20.8981 12.6138C20.9981 12.3088 20.9981 11.9668 20.9961 11.2868L20.9941 10.7128C20.9931 10.0298 20.9921 9.68783 20.8911 9.38283C20.8014 9.11356 20.6555 8.86643 20.4631 8.65783C20.2461 8.42183 19.9481 8.25583 19.3521 7.92483L19.3501 7.92383Z"
          stroke="#526C7B"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7 11.0009C7 12.0617 7.42143 13.0791 8.17157 13.8293C8.92172 14.5794 9.93913 15.0009 11 15.0009C12.0609 15.0009 13.0783 14.5794 13.8284 13.8293C14.5786 13.0791 15 12.0617 15 11.0009C15 9.93999 14.5786 8.92257 13.8284 8.17243C13.0783 7.42228 12.0609 7.00085 11 7.00085C9.93913 7.00085 8.92172 7.42228 8.17157 8.17243C7.42143 8.92257 7 9.93999 7 11.0009Z"
          stroke="#526C7B"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
  // {
  //   title: "Download",
  //   active: "Download",
  //   path: "/download",
  //   icon: (
  //     <svg
  //       width="24"
  //       height="21"
  //       viewBox="0 0 22 21"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <path
  //         d="M15.5903 10.3301H14.0003V2.33008C14.0003 1.78008 13.5503 1.33008 13.0003 1.33008H9.00026C8.45026 1.33008 8.00026 1.78008 8.00026 2.33008V10.3301H6.41026C5.52026 10.3301 5.07026 11.4101 5.70026 12.0401L10.2903 16.6301C10.6803 17.0201 11.3103 17.0201 11.7003 16.6301L16.2903 12.0401C16.9203 11.4101 16.4803 10.3301 15.5903 10.3301Z"
  //         stroke="#6A796E"
  //         stroke-width="1.5"
  //       />
  //       <path
  //         d="M1 19.8301H21"
  //         stroke="#6A796E"
  //         stroke-width="1.5"
  //         stroke-linecap="round"
  //       />
  //     </svg>
  //   ),
  // },
];

export default SidebarData;
